"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[170],{

/***/ 96963:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://images-prod.forumm.to/2972/_next/static/media/default-thumbnail.e3eaaa42.png","height":1055,"width":3000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAEklEQVR4nGP0XHrxPwMeQLkCAAg1CD6gtSBNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 25536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var draft_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9041);
/* harmony import */ var draft_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(draft_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);




const Editor = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 6925).then(__webpack_require__.t.bind(__webpack_require__, 35108, 23)).then((mod)=>mod.Editor), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35108)
            ]
    },
    ssr: false
});
const RichTextDisplay = (param)=>{
    let { descriptionJson , show =true  } = param;
    let editorState;
    const isJson = descriptionJson && typeof descriptionJson === "string" && descriptionJson.startsWith("{") && descriptionJson.endsWith("}");
    if (!isJson) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: descriptionJson
    });
    try {
        const parsedJson = JSON.parse(descriptionJson);
        const contentState = (0,draft_js__WEBPACK_IMPORTED_MODULE_2__.convertFromRaw)(parsedJson);
        editorState = draft_js__WEBPACK_IMPORTED_MODULE_2__.EditorState.createWithContent(contentState);
    } catch (e) {
        console.error("Error creating editor state from descriptionJson", e);
        const contentState1 = draft_js__WEBPACK_IMPORTED_MODULE_2__.ContentState.createFromText("Error displaying content");
        editorState = draft_js__WEBPACK_IMPORTED_MODULE_2__.EditorState.createWithContent(contentState1);
    }
    const customWrapperStyle = {
        margin: 0,
        padding: 0,
        border: "none"
    };
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Editor, {
        editorState: editorState,
        readOnly: true,
        toolbarHidden: true,
        wrapperStyle: customWrapperStyle
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RichTextDisplay);


/***/ }),

/***/ 29039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ carousel_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./libs/Utility/parsers.tsx
var parsers = __webpack_require__(40654);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./components/carousel/VideoModal.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 



const VideoModal = (param)=>{
    let { isOpen , videoUrl , onClose , isImage  } = param;
    if (!isOpen) return null;
    const [youtubeId, setYoutubeId] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setYoutubeId((0,parsers/* getYoutubeVideoId */.P9)(videoUrl));
    }, [
        videoUrl
    ]);
    const isYouTubeVideo = (0,parsers/* isYoutubeUrl */.Qd)(videoUrl);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4",
        onClick: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative w-full max-w-4xl bg-black",
            onClick: (e)=>e.stopPropagation(),
            children: [
                isImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: videoUrl,
                    alt: "",
                    width: "100%",
                    height: "100%",
                    style: {
                        maxHeight: "100%",
                        maxWidth: "100%"
                    }
                }),
                isYouTubeVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
                    videoId: youtubeId,
                    iframeClassName: "w-full h-full",
                    style: {
                        height: "550px"
                    },
                    className: "flex w-full overflow-hidden",
                    opts: {
                        height: "100%",
                        width: "100%"
                    }
                }),
                !isYouTubeVideo && !isImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: videoUrl,
                    controls: true,
                    autoPlay: true,
                    className: "w-full h-full"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onClose,
                    className: "absolute right-2 top-2 rounded-full py-1 px-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700",
                    children: "X"
                })
            ]
        })
    });
};
/* harmony default export */ var carousel_VideoModal = (VideoModal);

// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/base/RichTextDisplay.tsx
var RichTextDisplay = __webpack_require__(25536);
// EXTERNAL MODULE: ./components/ui/MediaThumbnail.tsx
var MediaThumbnail = __webpack_require__(26052);
;// CONCATENATED MODULE: ./components/carousel/Carousel.tsx








const Carousel = (param)=>{
    let { items , fixedHeight =true , show =true , className ="relative" , width , slideshow =false  } = param;
    var ref, ref1;
    const timer = (0,react.useRef)();
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [currentMediaUrl, setCurrentMediaUrl] = (0,react.useState)("");
    const [currIndex, setCurrIndex] = (0,react.useState)(0);
    const [isImage, setIsImage] = (0,react.useState)(false);
    const [content, setContent] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const parseMedia = async ()=>{
            const payload = await Promise.all(items.map(async (item)=>{
                return {
                    ...item,
                    isImage: await (0,parsers/* getMediaType */.V4)(item.url) === "IMAGE"
                };
            }));
            setContent(payload);
        };
        parseMedia();
    }, [
        items
    ]);
    const handleMediaClick = async (media)=>{
        const url = typeof media === "string" ? media : media.src;
        const isImage = await (0,parsers/* getMediaType */.V4)(url) === "IMAGE";
        setIsImage(isImage);
        setCurrentMediaUrl(url);
        setIsModalOpen(true);
    };
    const prevSlide = ()=>{
        pauseSlideshow();
        setCurrIndex((prevIndex)=>prevIndex === 0 ? items.length - 1 : prevIndex - 1);
    };
    const nextSlide = function() {
        let opt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            pause: true
        };
        if (opt.pause) pauseSlideshow();
        setCurrIndex((prevIndex)=>prevIndex === items.length - 1 ? 0 : prevIndex + 1);
    };
    const clearLoop = ()=>{
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = undefined;
        }
    };
    const pauseSlideshow = ()=>{
        if (!slideshow) return;
        clearLoop();
        setTimeout(()=>{
            const loop = setInterval(()=>{
                nextSlide({
                    pause: false
                });
            }, 4000);
            timer.current = loop;
        }, 8000);
    };
    (0,react.useEffect)(()=>{
        if (slideshow) {
            const loop = setInterval(()=>{
                if (!slideshow) return;
                nextSlide({
                    pause: false
                });
            }, 4000);
            clearLoop();
            timer.current = loop;
        }
        return ()=>clearLoop();
    }, []);
    // useEffect(() => {
    //   if (timer.current) clearInterval(timer.current)
    //   return () => clearInterval(timer.current)
    // }, [])
    const carouselRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const ele = carouselRef.current;
        let isPressing = false;
        let startX;
        const dragStart = (e)=>{
            document.onmousemove = dragMove;
            document.ontouchmove = dragMove;
            document.onmouseup = dragEnd;
            document.ontouchend = dragEnd;
            document.ontouchcancel = dragEnd;
            isPressing = true;
            if (e.type === "touchstart") {
                startX = e.touches[0].pageX;
            } else if (e.type === "mousedown") {
                startX = e.pageX;
            }
        };
        const dragMove = (e)=>{
            if (isPressing) {
                dragEnd();
                let currentX = startX;
                if (e.type === "touchmove") {
                    currentX = e.touches[0].pageX;
                } else if (e.type === "mousemove") {
                    currentX = e.pageX;
                }
                if (currentX < startX) nextSlide();
                if (currentX > startX) prevSlide();
            }
        };
        const dragEnd = ()=>{
            document.onmousemove = null;
            document.onmouseup = null;
            document.ontouchmove = null;
            document.ontouchend = null;
            document.ontouchcancel = null;
            isPressing = false;
        };
        if (ele) {
            ele.addEventListener("touchstart", dragStart);
            ele.addEventListener("mousedown", dragStart);
        }
        return ()=>{
            if (ele) {
                ele.removeEventListener("touchstart", dragStart);
                ele.removeEventListener("mousedown", dragStart);
            }
        };
    }, [
        carouselRef.current
    ]);
    if (!show) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    const prevIndex = currIndex - 1 < 0 ? items.length - 1 : currIndex - 1;
    const nextIndex = currIndex + 1 > items.length - 1 ? 0 : currIndex + 1;
    const targetIndexes = [
        prevIndex,
        currIndex,
        nextIndex
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: carouselRef,
        className: "".concat(className, " h-full relative"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_VideoModal, {
                isOpen: isModalOpen,
                videoUrl: currentMediaUrl,
                onClose: ()=>setIsModalOpen(false),
                isImage: isImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full w-full justify-center items-center relative max-w-[900px] mx-auto lg:max-h-[300px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full max-h-[20vh] max-w-[900px] h-[30em] transition-transform ease-out duration-500 relative justify-center items-center",
                        children: content.map((item, index)=>{
                            const isImage = item.isImage;
                            const isTarget = targetIndexes.includes(index);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none absolute max-h-[100%] ".concat(fixedHeight ? "size-[35em] md:h-[28em] md:w-[28em] lg:max-w-[200px] lg:max-h-[200px]" : "h-auto w-[".concat(width, "]"), " cursor-pointer ").concat(index),
                                style: {
                                    opacity: items.length < 3 && index !== currIndex ? "0" : isTarget ? "1" : "0",
                                    position: "absolute",
                                    transform: "perspective(75em) translateX(".concat(items.length < 3 ? "0%" : index == prevIndex ? "-100%" : index == nextIndex ? "100%" : "0%", ") rotateY(").concat(items.length < 3 ? "0deg" : prevIndex === index ? "-40deg" : nextIndex === index ? "40deg" : isTarget ? "0deg" : index < currIndex ? "-90deg" : "90deg", ") scale(").concat(index === currIndex ? "1" : "0.7", ")"),
                                    transition: "transform 500ms ease-in-out, opacity 200ms linear ".concat(isTarget ? "300ms" : "0ms"),
                                    zIndex: isTarget ? index === currIndex ? "19" : "15" : "10"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full h-full flex items-center justify-center relative",
                                    onClick: ()=>{
                                        item.onClick ? item.onClick(item) : handleMediaClick(item.url || "");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaThumbnail/* MediaThumbnail */.U, {
                                            media: item.url,
                                            alt: item.title,
                                            size: "any",
                                            className: "h-full ".concat(width ? "w-full" : "w-auto", " bg-none rounded-2xl")
                                        }, item.title.trim().replaceAll(" ", "_").toLowerCase()),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat(isImage && "hidden", " absolute text-white text-6xl"),
                                            children: "▶"
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    items.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: prevSlide,
                                className: "absolute top-[50%] left-0 p-2 rounded-full bg-white text-gray-800 hover:bg-gray-200 z-[20]",
                                style: {
                                    transform: "translateY(-50%)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowBack */.u1R, {
                                    className: "text-xl"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>nextSlide(),
                                className: "absolute top-[50%] right-0 p-2 rounded-full bg-white text-gray-800 hover:bg-gray-200 z-[20]",
                                style: {
                                    transform: "translateY(-50%)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowForward */.hjJ, {
                                    className: "text-xl"
                                })
                            })
                        ]
                    })
                ]
            }),
            items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-col w-full h-full px-6 sm:px-10 md:px-12 lg:px-16 mt-10 mx-auto text-center ml-4 mr-4 md:ml-0 md:mr-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-2xl font-medium w-full",
                        children: (ref = items[currIndex]) === null || ref === void 0 ? void 0 : ref.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-sm mt-3 font-small w-full max-w-[900px] mx-auto text-center",
                        style: {
                            whiteSpace: "pre-line"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                            descriptionJson: (ref1 = items[currIndex]) === null || ref1 === void 0 ? void 0 : ref1.description
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var carousel_Carousel = (Carousel);


/***/ }),

/***/ 20970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ToggleInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51773);




/**
 * Primary UI component for toggle input
 */ const ToggleInput = (param)=>{
    let { label , placeholder , onChange , className , hint , required , value , options , selected =0 , callback , centerText =false , show =true , error  } = param;
    const errorMessage = error;
    const hiddenFileInput = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const [toggleValue, setToggleValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selected !== null && selected !== void 0 ? selected : 0);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    const isLight = theme.type === "LIGHT";
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        htmlFor: "formToggle",
        className: [
            "flex flex-col text-sm space-y-1 text-white",
            className
        ].join(" "),
        children: [
            (errorMessage || label || hint) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "transition-all ".concat(required ? "pl-2" : "px-2", " ").concat(errorMessage ? "text-red-500" : isLight ? "text-black" : "text-white"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "z-10 ".concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                        children: [
                            errorMessage !== null && errorMessage !== void 0 ? errorMessage : label,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "\n        ".concat(isLight ? "text-black" : "text-white", " \n        ml-2 text-xs\n        "),
                        children: hint
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "flex w-full",
                children: options.map((c, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        className: "\n                py-1 flex justify-center items-center h-[55px] break-keep text-nowrap\n                ".concat(selected === index && "bg-forumm-blue-light-2", "\n                ").concat(index + 1 === options.length && "rounded-r-2xl", "\n                ").concat(index === 0 && "rounded-l-2xl", "\n                ").concat(centerText && "text-center", "\n                ").concat(isLight ? "border-forumm-gray-3" : "border-white", "\n                border py-2 px-3 cursor-pointer flex-1\n                ").concat(selected === index && "!text-[#181A20]", "\n              "),
                        onClick: async ()=>{
                            hiddenFileInput.current.value = c;
                            if (callback) return callback(c);
                        },
                        children: selected === index ? "✓  ".concat(c) : c
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                required: required,
                className: "hidden",
                type: "text",
                id: label,
                ref: hiddenFileInput,
                onChange: (e)=>{
                    if (onChange) onChange(e);
                },
                value: options[selected]
            })
        ]
    });
};


/***/ }),

/***/ 44714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ADD_STATISTIC; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const ADD_STATISTIC = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  mutation addStatistic(\n    $anonymousId: String\n    $userId: String\n    $url: String\n    $ip: String\n    $country: String\n    $browser: String\n  ) {\n    addStatistic(\n      anonymousId: $anonymousId\n      userId: $userId\n      url: $url\n      ip: $ip\n      country: $country\n      browser: $browser\n    )\n  }\n");


/***/ }),

/***/ 91875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getGeolocation; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5121);

const publicGeoAPifyKey = "94eca36f44d046199de1789193c7b867";
const getGeolocation = async ()=>{
    let address = "";
    let ip = "";
    if ( false || !publicGeoAPifyKey) {
        return {
            address,
            ip
        };
    }
    try {
        const response = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("https://api.geoapify.com/v1/ipinfo?&apiKey=".concat(publicGeoAPifyKey));
        if (response && response.data) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            const geoData = response === null || response === void 0 ? void 0 : response.data;
            address = "".concat(geoData === null || geoData === void 0 ? void 0 : (ref = geoData.country) === null || ref === void 0 ? void 0 : ref.name);
            ip = geoData === null || geoData === void 0 ? void 0 : geoData.ip;
            if (geoData === null || geoData === void 0 ? void 0 : (ref1 = geoData.state) === null || ref1 === void 0 ? void 0 : ref1.name) address += " | ".concat(geoData === null || geoData === void 0 ? void 0 : (ref2 = geoData.state) === null || ref2 === void 0 ? void 0 : ref2.name);
            if (geoData === null || geoData === void 0 ? void 0 : (ref3 = geoData.city) === null || ref3 === void 0 ? void 0 : ref3.name) address += " | ".concat(geoData === null || geoData === void 0 ? void 0 : (ref4 = geoData.city) === null || ref4 === void 0 ? void 0 : ref4.name);
            if (geoData === null || geoData === void 0 ? void 0 : geoData.location) address += " | lat: ".concat(geoData === null || geoData === void 0 ? void 0 : (ref5 = geoData.location) === null || ref5 === void 0 ? void 0 : ref5.latitude, " lng: ").concat(geoData === null || geoData === void 0 ? void 0 : (ref6 = geoData.location) === null || ref6 === void 0 ? void 0 : ref6.longitude);
        }
    } catch (_ex) {
        console.warn(_ex);
    }
    return {
        address,
        ip
    };
};


/***/ }),

/***/ 49981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ resolveRegistrationEventId; },
/* harmony export */   "P9": function() { return /* binding */ shouldShowDiscountCode; },
/* harmony export */   "PH": function() { return /* binding */ getRegistrationVideoUrl; },
/* harmony export */   "RC": function() { return /* binding */ getOrganisationConfig; },
/* harmony export */   "ce": function() { return /* binding */ CONFIG_OPTIONS; },
/* harmony export */   "jk": function() { return /* binding */ getRegistrationFieldErrors; },
/* harmony export */   "lx": function() { return /* binding */ getAdditionalTicketsForCount; },
/* harmony export */   "rS": function() { return /* binding */ getRegistrationConfig; },
/* harmony export */   "vE": function() { return /* binding */ areAllTicketRegistrationFieldsFilled; },
/* harmony export */   "xG": function() { return /* binding */ isVatIncludedForOrganisation; }
/* harmony export */ });
/* unused harmony exports QUICK_REGISTRATION_EVENT_IDS, VAT_EXCLUDED_ORGANISATIONS */
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68240);

var CONFIG_OPTIONS;
(function(CONFIG_OPTIONS) {
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_FULL_REGISTRATION_OPTIONS"] = 0] = "SHOW_FULL_REGISTRATION_OPTIONS";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_ACCOUNT_PROMPT"] = 1] = "SHOW_ACCOUNT_PROMPT";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_VISIBLE_REGISTRATION_OPT_IN"] = 2] = "SHOW_VISIBLE_REGISTRATION_OPT_IN";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_ATTENDEE_BOX"] = 3] = "SHOW_ATTENDEE_BOX";
    CONFIG_OPTIONS[CONFIG_OPTIONS["ALLOW_DIRECT_DEBIT"] = 4] = "ALLOW_DIRECT_DEBIT";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_GOOGLE_ADS"] = 5] = "SHOW_GOOGLE_ADS";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_QUICK_REGISTRATION_OPTIONS"] = 6] = "SHOW_QUICK_REGISTRATION_OPTIONS";
})(CONFIG_OPTIONS || (CONFIG_OPTIONS = {}));
const QUICK_REGISTRATION_EVENT_IDS = (/* unused pure expression or super */ null && ([
    "31fffe01-557f-4c3c-a7f3-cb1ec9772277",
    "0ca669ca-b167-4f69-a211-6817ad502349",
    "ed27bac1-0db6-46b0-a4b3-51f4a0993cb5",
    "e43c495e-1ebf-4bd0-8902-d524f26c0d1a",
    "4f25f4db-9795-44b7-b639-5ede8cb8c4fc"
]));
const VAT_EXCLUDED_ORGANISATIONS = [
    "Sales Geek Essex",
    "Sales Geek Scotland",
    "The LSP Compliance Group",
    "egg",
    "Imaginary Friends",
    "Simaril Events",
    "Silmaril Events"
];
const DEFAULT_REGISTRATION_VIDEO_URL = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background.mp4";
const EVENT_REGISTRATION_VIDEO_URLS = {
    "c987cfd9-3732-4d21-a586-293ed6d36784": "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background_CE.mp4",
    "c2cba07a-a403-440c-8f0e-6f0788ad907b": "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Infinite+Intentions+Video+(1).mp4",
    "acc6d01b-d339-4dfc-9df3-8ccef3ec7594": "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/The+Scottish+Marketing+Network+Highlight+Reel.mp4",
    "deef2f23-a324-42bb-8cac-e632e135faee": "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Hampden+Park+Banner.jpg",
    "795fdc4b-10fa-4f16-8be6-7046e1b3a6bc": "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Hampden+Park+Banner.jpg",
    "91947a10-235c-4e1e-94bd-442257efec8d": "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Celtic+Park+Background.png"
};
const resolveRegistrationEventId = (eventIdQuery, eventIdsMap)=>{
    const routeEventId = Array.isArray(eventIdQuery) ? eventIdQuery[0] : eventIdQuery;
    if (!routeEventId) return routeEventId;
    const decodedEventId = decodeURIComponent(routeEventId).trim().toLowerCase();
    if (eventIdsMap[routeEventId]) return eventIdsMap[routeEventId];
    if (eventIdsMap[decodedEventId]) return eventIdsMap[decodedEventId];
    return routeEventId;
};
const getRegistrationVideoUrl = (eventId)=>{
    if (!eventId) return DEFAULT_REGISTRATION_VIDEO_URL;
    var _eventId;
    return (_eventId = EVENT_REGISTRATION_VIDEO_URLS[eventId]) !== null && _eventId !== void 0 ? _eventId : DEFAULT_REGISTRATION_VIDEO_URL;
};
const isVatIncludedForOrganisation = (organisationName)=>{
    return !VAT_EXCLUDED_ORGANISATIONS.includes(organisationName !== null && organisationName !== void 0 ? organisationName : "");
};
const getAdditionalTicketsForCount = (param)=>{
    let { currentTickets , requestedCount , enabled , selectedTicketName , defaultTicketTitle  } = param;
    if (!enabled) return [];
    if (currentTickets.length > requestedCount) {
        return currentTickets.slice(0, requestedCount);
    }
    let additionalTickets = [
        ...currentTickets
    ];
    while(additionalTickets.length < requestedCount){
        additionalTickets = [
            ...additionalTickets,
            {
                title: selectedTicketName !== null && selectedTicketName !== void 0 ? selectedTicketName : defaultTicketTitle,
                fullName: ""
            }
        ];
    }
    return additionalTickets;
};
const shouldShowDiscountCode = (param)=>{
    let { availableTickets , discountPercentage , ticketTotalPrice  } = param;
    const hasPrice = (ticketTotalPrice !== null && ticketTotalPrice !== void 0 ? ticketTotalPrice : 0) > 0 || discountPercentage === 100;
    const discountsRemaining = availableTickets.reduce((total, ticket)=>{
        var ref;
        const availableDiscount = (ref = ticket.discountCodes) === null || ref === void 0 ? void 0 : ref.reduce((count, discount)=>{
            if (discount.remaining && discount.remaining > 0) {
                return count + discount.remaining;
            }
            return count;
        }, 0);
        return total + (availableDiscount !== null && availableDiscount !== void 0 ? availableDiscount : 0);
    }, 0);
    return hasPrice && discountsRemaining > 0;
};
const areAllTicketRegistrationFieldsFilled = (fieldVals, totalTickets, fieldsToValidate)=>{
    if (fieldsToValidate.length === 0) return true;
    if (!Array.isArray(fieldVals)) return false;
    if (fieldVals.length !== totalTickets) return false;
    return fieldVals.every((row)=>{
        return fieldsToValidate.every((field)=>{
            if (typeof row[field] === "boolean") return row[field];
            if (typeof row[field] === "string") return row[field].trim() !== "";
            return !!row[field];
        });
    });
};
const getRegistrationFieldErrorKey = (attendeeIndex, fieldName)=>"".concat(attendeeIndex, "::").concat(fieldName.replaceAll(" ", "_").toLowerCase());
const compileRegistrationAnswers = (answers)=>{
    const sortedAnswers = {};
    answers.forEach((registrationAnswers)=>{
        registrationAnswers.forEach((answer)=>{
            if (!!answer.value) !!sortedAnswers[answer.name] ? sortedAnswers[answer.name].push(answer.value) : sortedAnswers[answer.name] = [
                answer.value
            ];
        });
    });
    return sortedAnswers;
};
const getRegistrationFieldErrors = (param)=>{
    let { event , usersData , fieldVals , selectedAttendeeIndex  } = param;
    var ref, ref1;
    const payload = {};
    const uniqueRegFields = event === null || event === void 0 ? void 0 : (ref = event.registrationFields) === null || ref === void 0 ? void 0 : ref.filter((registrationField)=>!!registrationField.unique).map((registrationField)=>registrationField.name);
    const requiredRegFields = event === null || event === void 0 ? void 0 : (ref1 = event.registrationFields) === null || ref1 === void 0 ? void 0 : ref1.filter((registrationField)=>!!registrationField.required).map((registrationField)=>registrationField.name);
    const regAnswers = usersData.map((fieldValue)=>{
        return Object.keys(fieldValue !== null && fieldValue !== void 0 ? fieldValue : {}).map((key)=>({
                name: key,
                value: fieldValue[key]
            }));
    });
    if ((uniqueRegFields === null || uniqueRegFields === void 0 ? void 0 : uniqueRegFields.length) === 0 && (requiredRegFields === null || requiredRegFields === void 0 ? void 0 : requiredRegFields.length) === 0) {
        return payload;
    }
    requiredRegFields === null || requiredRegFields === void 0 ? void 0 : requiredRegFields.forEach((requiredFieldName)=>{
        if (!!fieldVals && fieldVals.length > 0 && fieldVals.length > (selectedAttendeeIndex !== null && selectedAttendeeIndex !== void 0 ? selectedAttendeeIndex : 0)) {
            fieldVals.filter((_, index)=>{
                if (!selectedAttendeeIndex) return true;
                if (selectedAttendeeIndex === index) return true;
                return false;
            }).forEach((fieldValue, index)=>{
                const attendeeIndex = selectedAttendeeIndex !== null && selectedAttendeeIndex !== void 0 ? selectedAttendeeIndex : index;
                if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue[requiredFieldName])) {
                    payload[getRegistrationFieldErrorKey(attendeeIndex, requiredFieldName)] = "This answer is required to move forward.";
                }
            });
        } else {
            payload[getRegistrationFieldErrorKey(selectedAttendeeIndex !== null && selectedAttendeeIndex !== void 0 ? selectedAttendeeIndex : 0, requiredFieldName)] = "This answer is required to move forward.";
        }
    });
    uniqueRegFields === null || uniqueRegFields === void 0 ? void 0 : uniqueRegFields.forEach((uniqueFieldName)=>{
        if (!!fieldVals && fieldVals.length > 0) {
            fieldVals.forEach((fieldValue, index)=>{
                var ref;
                const fieldValueAnswers = [];
                fieldVals.forEach((otherFieldValue, otherIndex)=>{
                    if (otherIndex !== index) fieldValueAnswers.push(Object.keys(otherFieldValue !== null && otherFieldValue !== void 0 ? otherFieldValue : {}).map((key)=>({
                            name: key,
                            value: otherFieldValue[key]
                        })));
                });
                const sortedAnswers = compileRegistrationAnswers([
                    ...regAnswers,
                    ...fieldValueAnswers
                ]);
                if (!!(sortedAnswers === null || sortedAnswers === void 0 ? void 0 : (ref = sortedAnswers[uniqueFieldName]) === null || ref === void 0 ? void 0 : ref.length)) {
                    if ((fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue[uniqueFieldName]) && sortedAnswers[uniqueFieldName].includes(fieldValue[uniqueFieldName])) {
                        payload[getRegistrationFieldErrorKey(index, uniqueFieldName)] = "This answer has already been given by another attendee.";
                    }
                }
            });
        }
    });
    return payload;
};
// NOTE: Temporary config options
const getRegistrationConfig = (opt, event)=>{
    var ref, ref1, ref2;
    // console.log(`[RegistrationConfig]: `, { opt, event })
    if (!event) return true;
    const isInPerson = ((ref = event.event) === null || ref === void 0 ? void 0 : ref.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .EventType.InPerson */ .tw.InPerson;
    var ref3;
    // const isOnline = event.event?.eventType === EventType.Online
    const orgName = (ref3 = event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.organizationName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) !== null && ref3 !== void 0 ? ref3 : "";
    switch(opt){
        case CONFIG_OPTIONS.SHOW_ACCOUNT_PROMPT:
            if (orgName.includes("sussex")) return false;
            if (orgName.includes("448 studio")) return false;
            break;
        case CONFIG_OPTIONS.SHOW_FULL_REGISTRATION_OPTIONS:
            if (orgName.includes("sussex")) return false;
            if (orgName.includes("448 studio")) return false;
            break;
        case CONFIG_OPTIONS.SHOW_VISIBLE_REGISTRATION_OPT_IN:
            if (orgName.includes("sussex")) return true;
            if (orgName.includes("forumm")) return true;
            // if (orgName.includes('imaginary friends')) return true
            if (event.eventId === "16caaaed-dc0d-44d7-936d-0a590dfef429") return true;
            if (event.eventId === "31fffe01-557f-4c3c-a7f3-cb1ec9772277") return true;
            return false;
        case CONFIG_OPTIONS.ALLOW_DIRECT_DEBIT:
            if (orgName.includes("sussex")) return true;
            if (orgName.includes("448 studio")) return true;
            if (orgName.includes("forumm")) return true;
            return false;
        case CONFIG_OPTIONS.SHOW_ATTENDEE_BOX:
            if (orgName.includes("sussex")) return true;
            // if (orgName.includes('imaginary friends')) return true
            if (orgName.includes("university of glasgow") && isInPerson) return true;
            if (event.eventId === "16caaaed-dc0d-44d7-936d-0a590dfef429") return true;
            if (event.eventId === "e172670e-a062-4f05-9e33-b334a57fff93") return true;
            return false;
        case CONFIG_OPTIONS.SHOW_QUICK_REGISTRATION_OPTIONS:
            if (event.eventId === "236e01cf-bcfb-41e0-94e9-4c173e2e16f4") return false;
            if (event.eventId === "59080128-59d6-4164-a824-0e48b01ef75f") return false;
            return true;
    }
    return true;
};
const getOrganisationConfig = (opt, orgName)=>{
    // console.log(`[OrganisationConfig]: `, { opt, orgName })
    if (!orgName) return true;
    const sanitisedOrgName = orgName.toLowerCase();
    switch(opt){
        case CONFIG_OPTIONS.SHOW_GOOGLE_ADS:
            if (sanitisedOrgName.includes("sussex")) return false;
            return true;
    }
    return true;
};


/***/ }),

/***/ 30530:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const currencies = {
    CAD: {
        symbol: "$",
        name: "Canadian Dollar"
    },
    USD: {
        symbol: "$",
        name: "US Dollar"
    },
    EUR: {
        symbol: "€",
        name: "Euro"
    },
    GBP: {
        symbol: "\xa3",
        name: "British Pound"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (currencies);


/***/ }),

/***/ 23638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57632);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72742);
/* harmony import */ var _libs_useLocalStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3830);
/* harmony import */ var _graphql_statistic_addStatistic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44714);
/* harmony import */ var _Utility_geoip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91875);






const useStatistics = ()=>{
    const [done, setDone] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [addStatistic] = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(_graphql_statistic_addStatistic__WEBPACK_IMPORTED_MODULE_2__/* .ADD_STATISTIC */ ._);
    const [statisticId, setStatisticId] = (0,_libs_useLocalStorage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Forum_Statistic_Tracker", "");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if ( true && !statisticId) {
            setStatisticId((0,uuid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)());
        }
    }, [
        statisticId,
        setStatisticId
    ]);
    const onReady = async ()=>{
        try {
            var ref, ref1;
            setDone(true);
            if ( false || typeof _Utility_geoip__WEBPACK_IMPORTED_MODULE_5__/* .getGeolocation */ .Y !== "function") return;
            const currentFullUrl = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href;
            const browser = window === null || window === void 0 ? void 0 : (ref1 = window.navigator) === null || ref1 === void 0 ? void 0 : ref1.userAgent;
            const { address , ip  } = await (0,_Utility_geoip__WEBPACK_IMPORTED_MODULE_5__/* .getGeolocation */ .Y)();
            await addStatistic({
                variables: {
                    anonymousId: statisticId,
                    url: currentFullUrl,
                    country: address,
                    browser,
                    ip
                }
            });
        } catch (error) {
            console.warn(error);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!done && "object" !== "undefined" && statisticId) {
            onReady();
        }
    }, [
        statisticId,
        addStatistic,
        done
    ]);
    return statisticId;
};
/* harmony default export */ __webpack_exports__["Z"] = (useStatistics);


/***/ })

}]);